// src/components/ReviewsTicker.js
import React, { useMemo } from 'react';
import logo_reddit from '../images/logo_reddit.png';
import tiktokLogo from '../images/tiktoklogo.svg';
import youtubeLogo from '../images/youtubelogo.svg';
import matchMedicLogo from '../images/mm_logo.png';
import hairRestorationLogo from '../images/HRNlogo.png';
import hairLossLogo from '../images/hairlossexperiences.png';
import reviewsData from '../components/reviewsData';

const placeholderLogos = {
  reddit: logo_reddit,
  tiktok: tiktokLogo,
  youtube: youtubeLogo,
  'match-medic': matchMedicLogo,
  hairrestorationnetwork: hairRestorationLogo,
  hairlossexperiences: hairLossLogo,
};

const smallLogoSources = ['tiktok', 'match-medic', 'hairrestorationnetwork'];

// Helper function to format source names for display
const formatSourceName = (source) => {
  switch(source) {
    case 'reddit':
      return 'Reddit';
    case 'tiktok':
      return 'TikTok';
    case 'youtube':
      return 'YouTube';
    case 'match-medic':
      return 'Match Medic';
    case 'hairrestorationnetwork':
      return 'Hair Restoration Network';
    case 'hairlossexperiences':
      return 'Hair Loss Experiences';
    default:
      return source;
  }
};

// Shuffle helper
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const ReviewsTicker = ({ scrollSpeed = 60 }) => {
  // Shuffle once on mount
  const randomizedReviews = useMemo(() => {
    const shuffled = shuffleArray(reviewsData);
    return [...shuffled, ...shuffled]; // Duplicate for seamless scrolling
  }, []);

  // Create animation keyframes and style dynamically
  const scrollingAnimation = `
    @keyframes scroll {
      0% { transform: translateY(0); }
      100% { transform: translateY(-50%); }
    }
  `;

  const scrollingContentStyle = {
    animation: `scroll ${scrollSpeed}s linear infinite`,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  };

  // Container styles
  const containerStyle = {
    height: '300px',
    width: '500px',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: '#fff',
    borderRadius: '8px',
  };

  // Fade effect styles
  const fadeTopStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '60px',
    background: 'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
    zIndex: 2,
    pointerEvents: 'none',
  };

  const fadeBottomStyle = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '60px',
    background: 'linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)',
    zIndex: 2,
    pointerEvents: 'none',
  };

  return (
    <div className="border-0 reviews-ticker" style={containerStyle}>
      {/* Fade overlay at the top */}
      <div style={fadeTopStyle}></div>
      
      {/* Fade overlay at the bottom */}
      <div style={fadeBottomStyle}></div>
      
      <style>{scrollingAnimation}</style>
      <div className="scrolling-content" style={scrollingContentStyle}>
        {randomizedReviews.map((review, i) => {
          const isSmall = smallLogoSources.includes(review.source);
          const formattedSource = formatSourceName(review.source);
          
          return (
            <div 
              key={`${review.username}-${i}`} 
              className="review-row"
              style={{
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                borderBottom: '1px solid #f5f5f5',
              }}
            >
              <span style={{ fontWeight: 400 }}>{review.username}</span>
              <span style={{ margin: '0 8px', fontWeight: 300 }}>from</span>
              <span style={{ fontWeight: 300, marginRight: '8px' }}>{formattedSource}</span>
              <img
                src={placeholderLogos[review.source]}
                alt={review.source}
                style={{
                  width: isSmall ? '56px' : '56px',
                  height: isSmall ? '32px' : '32px',
                  objectFit: 'contain',
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReviewsTicker;